import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ArcGisToken } from 'dnv-lib';


@Injectable()
export class ArcGisService {

  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  constructor(
    private httpClient: HttpClient
  ) { }

  RenewArcGisToken(): Observable<ArcGisToken> {
    return this.httpClient.get<ArcGisToken>('api/esri/token', this.httpOptions);
  }

}
